import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useAuth, homeFor } from "../context/AuthContext";

export const Navbar = () => {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#EEF1ED]/80 border-b border-slate-200/60">
      <nav className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-[#4B5A54]">
          <a href="#how" data-testid="nav-how-link" className="hover:text-[#1A2B25] transition-colors">How it works</a>
          <a href="#features" data-testid="nav-features-link" className="hover:text-[#1A2B25] transition-colors">Features</a>
          <a href="#pricing" data-testid="nav-pricing-link" className="hover:text-[#1A2B25] transition-colors">Pricing</a>
        </div>
        <div className="flex items-center gap-2">
          {user ? (
            <Link to={homeFor(user)} data-testid="nav-dashboard-button" className="btn-primary">Dashboard</Link>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-button" className="px-2.5 sm:px-4 py-2 text-sm font-semibold text-[#1A2B25] rounded-xl hover:bg-slate-100 transition-colors whitespace-nowrap">Log in</Link>
              <Link to="/register" data-testid="nav-signup-button" className="btn-primary whitespace-nowrap !px-3 sm:!px-5">Get started</Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};
